import braintree from "braintree-web";

// Test if Apple Pay is available
function isAvailable() {
    return (window.ApplePaySession && ApplePaySession.supportsVersion(3) && ApplePaySession.canMakePayments())
}

// Set up Apple Pay with Braintree client authorization
async function setup(clientAuthorization) {
    // Check if Apple Pay is supported
    if (typeof ApplePaySession === "undefined") {
      console.error("This device does not support Apple Pay");
      return null;
    }

    if (!ApplePaySession.canMakePayments()) {
      console.error("This device is not capable of making Apple Pay payments");
      return null;
    }

    try {
      // Create a Braintree client instance
      console.log("Creating Braintree client instance for Apple Pay...");
      const clientInstance = await braintree.client.create({
        authorization: clientAuthorization,
      });

      // Create a Braintree Apple Pay instance
      console.log("Creating Braintree Apple Pay instance...");
      const applePayInstance = await braintree.applePay.create({
        client: clientInstance,
      });

      console.log("Apple Pay instance is set up and ready to use");
      return { applePayInstance, clientInstance };
    } catch (err) {
      console.error("Error setting up Apple Pay:", err);
      return null;
    }
}

// Create an Apple Pay session
// function createSession(applePayInstance, totalAmount) {
//     try {
//       // Create a payment request using the Apple Pay instance
//       const paymentRequest = applePayInstance.createPaymentRequest({
//         total: {
//           label: "In His Hands Birth Supply",
//           amount: totalAmount,
//         },
//         // Collect billing address information, including postal code
//         requiredBillingContactFields: ["postalAddress", "name", "email", "phone"],
//       });

//       // Log the payment request details (for debugging purposes)
//       console.log("Apple Pay Payment Request Details:");
//       console.log("Apple Pay Country Code:", paymentRequest.countryCode);
//       console.log("Apple Pay Currency Code:", paymentRequest.currencyCode);
//       console.log("Apple Pay Merchant Capabilities:", paymentRequest.merchantCapabilities);
//       console.log("Apple Pay Merchant Supported Networks:", paymentRequest.supportedNetworks);

//       console.log("Apple Pay Full Payment Request:", paymentRequest);

//       // Create and return a new Apple Pay session
//       try {
//           console.log("Creating new session...")
//           const session = new ApplePaySession(3, paymentRequest);
//           console.log("Session object: ", session);
//           console.log("Session stringified: ", JSON.stringify(session));
//           return session;
//       } catch (error) {
//         console.error("Error creating Apple Pay session:", error);
//         return null;

//       }
//     } catch (error) {
//       console.error("Error creating Apple Pay session:", error);
//       return null;
//     }
// }

// Validate the merchant session
async function validateMerchant(applePayInstance, session, validationURL, displayName = "In His Hands Birth Supply") {
    try {
      const merchantSession = await applePayInstance.performValidation({
        validationURL,
        displayName,
      });

      session.completeMerchantValidation(merchantSession);
      console.log("Merchant validation completed successfully");
    } catch (error) {
      console.error("Error validating merchant:", error);
      session.abort();
      throw new Error("Merchant validation failed");
    }
}

// Handle the Apple Pay authorization
async function handleAuthorization(applePayInstance, session, event) {
    try {
      console.log("Your shipping address is:", event.payment.shippingContact);

      // Tokenize the payment
      const payload = await applePayInstance.tokenize({
        token: event.payment.token,
      });

      console.log("Apple Pay client nonce:", payload.nonce);
      console.log("Apple Pay billingContact:", event.payment.billingContact);

      return { nonce: payload.nonce, billingContact: event.payment.billingContact };

    } catch (error) {
      console.error("Error tokenizing Apple Pay:", error);
      session.completePayment(ApplePaySession.STATUS_FAILURE);
    }
}


export default {
    isAvailable,
    setup,
    // createSession,
    validateMerchant,
    handleAuthorization,
}
